import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'

export default class TrafficRow extends Component {
  static propTypes = {
    date: PropTypes.string,
    weekDay: PropTypes.string,
    project: PropTypes.string,
    task: PropTypes.string,
    tTime: PropTypes.string,
    tSegments: PropTypes.array,
    note: PropTypes.string,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { date, weekDay, project, task, tTime, tSegments = [], note } = this.props
    return (
      <tr className={styles.printRow}>
        <td style={{ width: '6em' }}>{date.substr(2)}</td>
        <td style={{ width: '3em' }}>{weekDay}</td>
        <td style={{ width: '24em', textAlign: 'left' }}>{project}</td>
        <td style={{ width: '8em' }}>{task}</td>
        <td style={{ width: '3em' }}>{tTime}</td>
        <td style={{ width: '8em' }}>
          {tSegments.map((seg, i, arr) =>
            <div key={i}>{
                `${misc.getTimeStr(seg.start)} ~ ${misc.getTimeStr(seg.end)}`
            }</div>
          )}
        </td>
        <td style={{ width: '17em', textAlign: 'left' }}>{note}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/trafficRow.jsx